var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestMade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32.998,
    viewBox: "0 0 33 32.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ff4e4e;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M145.156,138.327l-14.582,4.738a.305.305,0,0,1-.275-.039.3.3,0,0,1-.03-.021.324.324,0,0,1-.106-.145s0,0-.006-.008a.343.343,0,0,1-.006-.052.319.319,0,0,1-.01-.05V127.421a15.337,15.337,0,1,0,15.015,10.906Z",
    transform: "translate(-114.472 -126.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,16a16,16,0,0,1,31.205-4.971.209.209,0,0,1,.015.027.144.144,0,0,1,0,.026A16,16,0,1,1,0,16Zm.662,0a15.338,15.338,0,1,0,30.023-4.423L16.1,16.314a.313.313,0,0,1-.1.017.321.321,0,0,1-.172-.055c-.012-.007-.02-.014-.032-.022a.325.325,0,0,1-.106-.144s0-.005,0-.008,0-.036-.007-.052a.483.483,0,0,1-.01-.05V.67A15.354,15.354,0,0,0,.662,16Zm15.669-.456,14.148-4.6A15.361,15.361,0,0,0,16.331.67,15.359,15.359,0,0,1,30.478,10.947Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestMade);
export default __webpack_public_path__ + "static/media/request-made.9e274c44201c9118e584c3679f06cad6.svg";
export { ForwardRef as ReactComponent };